export enum MODE {
  DARK = 'dark',
  LIGHT = 'light',
  SYSTEM = 'system',
}